import { render } from "./ProfileRequests.view.vue?vue&type=template&id=3fa8d078"
import script from "./ProfileRequests.view.vue?vue&type=script&lang=js"
export * from "./ProfileRequests.view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__